function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#d01c1f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9h30v12H0v-12Z",
    style: {
      fill: "#00a95c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.99,12.44h1.53l.48-1.44.48,1.44h1.53l-1.26.92.51,1.46-1.26-.9-1.26.9.51-1.46-1.26-.92ZM7.5,11.7c.682,3.422,4.592,5.74,8.735,5.177,3.216-.437,5.736-2.52,6.265-5.177,0,4.032-3.358,7.3-7.5,7.3s-7.5-3.268-7.5-7.3Z",
    style: {
      fill: "gold"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMr);
export default __webpack_public_path__ + "static/media/MR.f01cbf10bd5ea24fb706a2ef0419286d.svg";
export { ForwardRef as ReactComponent };